import React, { useRef } from 'react'
import { Input } from 'antd-mobile'
import { InputProps } from 'antd-mobile/es/components/Input'
import _ from 'lodash'

/**
 * 数字输入框，支持小数，最大最小值设置
 */

 export interface NumericInputProps extends InputProps {
    min?: number // 最小值
    max?: number // 最大值
    decimal?: number // 最大小数位数
    canEmpty?: boolean // 设置了最小值的情况下，是否支持输入空值，只有设置了min值的情况下才有效
    style?: any
}

const NumericInput: React.FC<NumericInputProps> = ({canEmpty = true, ...props}) => {

    // 修改值
    const handleChange = (value) => {
        let reg = /^\d*(\.\d*)?$/
        if(props.min < 0) {
            reg = /^(\-?)\d*(\.\d*)?$/
        }

        if(!reg.test(value)) {
            if(_.isFunction(props.onChange)) {
                props.onChange(props.value || '')
            }
            return
        }

        if ((!!props.max || props.max === 0) && value * 1 > props.max) {
            // 超出最大值
            if(_.isFunction(props.onChange)) {
                props.onChange(props.max)
            }
            return
        }
        const decimal = value.split('.')[1]
        if (props.decimal === 0 && decimal) {
            // 只能输入整数
            if(_.isFunction(props.onChange)) {
                props.onChange(value.split('.')[0])
            }
            return
        } else if (props.decimal){
            // 带有小数
            if (decimal && decimal.length > props.decimal) {
                if(_.isFunction(props.onChange)) {
                    props.onChange(value.split('.')[0] + '.' + value.split('.')[1].slice(0, props.decimal))
                }
                return
            }
        }

        // 是否合法的数字
        const isLegitimate = (!isNaN(value) && reg.test(value)) || value === '' || (props.min < 0 && value === '-')

        if (isLegitimate) {
            if(_.isFunction(props.onChange)) {
                props.onChange(value)
            }
            return
        }
    }

    // 焦点消失
    const handleBlur = (e) => {
        const { value } = e.target
        const { onChange, min, onBlur } = props
        onBlur && onBlur()
        let valueTemp = value
        if (value && (value.charAt(value.length - 1) === '.')) {
            valueTemp = value.slice(0, -1)
        }
        if (valueTemp && /^0+(\d+)/.test(valueTemp)) {
            onChange && onChange(valueTemp.replace(/0*(\d+)/, '$1'))
        }
        if ((!!min || min === 0) && (valueTemp * 1 < min || valueTemp === '')) {
            // 超出最小值
            if(!canEmpty || !!valueTemp || valueTemp === 0) {
                onChange(min)
            }
        }
    }

    const _props = {
        ...props
    }
    return (
        <Input
            type='number'
            {..._props}
            onChange={handleChange}
            onBlur={handleBlur}
            maxLength={9}
        />
    )
}

export default NumericInput